/* eslint-disable no-param-reassign */
import React from 'react';
import styles from '../index.css';
import Divider from '@tencent/dui/lib/components/Divider';
import Menu from '@tencent/dui/lib/components/Menu';
import MoreSettingIcon from '../../../../frame-pc/components/palette-panel/images/more-setting.svg';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '../../../../../slide/infrastructure/module/dependent/report/offline-data-report/constant';
import i18n from '@i18next/i18n';
import { checkChildModelHasProperty } from '@src/framework/frame/components/tool-bar/common/compare-property';
import { EFFECT_KEY } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IRightSideBarManager } from '@src/slide/application/service/right-side-bar-manager/right-side-bar-manager.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import ShadowPresetMenu from '@src/framework/frame-pc/components/palette-panel/effect-preset-menu/shadow-preset-menu';
import ReflectionPresetMenu from '@src/framework/frame-pc/components/palette-panel/effect-preset-menu/reflection-preset-menu';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import GlowPresetMenu from '@src/framework/frame-pc/components/palette-panel/effect-preset-menu/glow-preset-menu';
import SoftEdgePresetMenu from '@src/framework/frame-pc/components/palette-panel/effect-preset-menu/soft-edge-preset-menu';
import { PropertyEditorShowAction } from '@src/js/constant';
import { PresetUtilFactory } from '@src/framework/frame-pc/components/palette-panel/effect-preset-menu/preset-util/preset-util-facotry';
import PreviewService from '@src/slide/application/service/preview-service';
import { IThemeColorManager } from '@src/slide/application/service/theme-color-manager/index.interface';
import { PresetElementType } from '@src/framework/workbench/const/preset-element-type';
import _remove from 'lodash/remove';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import _isEqualWith from 'lodash/isEqualWith';

const TdwModuleAndOperation = {
    opername: TDWOperationType.DOC_PPT,
    module: TDWModuleType.PC_EDIT_PROFORMAT_PA,
};

const TdwEffectActions = {
    shadow: { action: TDWActionType.SHADOW_CLK },
    reflection: { action: TDWActionType.REFELECTION_CLK },
    glow: { action: TDWActionType.GLOW_CLK },
    softEdge: { action: TDWActionType.SOFTEDGE_CLK },
    open: { action: TDWActionType.OPEN_TOOLBAR_EFFECT },
    more: { action: TDWActionType.MORE_EFFECT_SETTING },
    no: { action: TDWActionType.NO_CLK },
};

const PropertyEditorShowActionMap = {
    shadow: PropertyEditorShowAction.SHADOW_TOGGLE,
    reflection: PropertyEditorShowAction.REFLECTION_TOGGLE,
    glow: PropertyEditorShowAction.GLOW_TOGGLE,
    softEdge: PropertyEditorShowAction.SOFTEDGE_TOGGLE,
};

const menuStyle = {
    margin: '-8px 0',
    border: 0,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    backdropFilter: 'none',
};

interface EffectMenuProps {
    hideMenu: () => void;
    data: Array<any>;
    handleClick?: () => void;
    rightSideBarManager: IRightSideBarManager | undefined;
    selectionService: ISelectionService;
    // honver到菜单上时， 是否显示预设效果面板
    showPresetMenu?: boolean;
    previewService?: PreviewService;
    checkSelectType?: () => number
    showMore?: boolean;
    themeColorManager?: IThemeColorManager;
    presetElementType: PresetElementType;
    callbackByActionType?: (actionType, obj?: any, option?: any) => void;
}

const EffectMenu = (props: EffectMenuProps) => {
    const { hideMenu, data, showPresetMenu, themeColorManager, presetElementType } = props;
    const model = props.selectionService.getSelectedModel() as IElementBaseModel;

    const getPropertyMenu = () => {
        const model = props.selectionService.getSelectedModel() as IElementBaseModel;
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices).
            editableServiceLayer?.menuManager.propertyMenu(model);
    };

    const getFontEffect = (type?: string) => {
        const effects = getPropertyMenu()?.values?.[ActionType.FONT_EFFECT];
        if (type) {
            return effects?.[type];
        }
        return effects;
    };

    const isTextEffect = presetElementType === PresetElementType.TEXT;
    const menuValue = isTextEffect ? getFontEffect() : model?.getEffect?.().getEffectCollection();
    const menuValueProps = {
        glow: { ...menuValue?.glow },
        softEdge: { ...menuValue?.softEdge },
        shadow: { ...menuValue?.shadow },
        reflection: { ...menuValue?.reflection },
    };
    const clearAllEffects = () => {
        hideMenu();
        if (isTextEffect) {
            Object.keys(menuValue).forEach((type) => {
                updateTextEffect(type, null, true);
            });
        } else {
            if (!menuValue) {
                // 为多选元素，且某个元素有效果
                if (checkChildModelHasProperty(model, EFFECT_KEY)) {
                    model.getEffect?.().updateEffectCollection(null, false);
                }
                return;
            }
            Object.keys(menuValue).forEach((type) => {
                model.getEffect?.().updateEffectCollection({ [type]: null }, false);
            });
        }
        tdw({ ...TdwModuleAndOperation, ...TdwEffectActions.no });
    };

    const hasEffect = (type) => {
        const effectProps = menuValue?.[type];
        return effectProps?.size !== 0;
    };

    const naviToEffectMenuOnPropertyEditor = (type) => {
        hideMenu();
        // 需在更新元素数据之前先给propertyEditorShowAction赋值，否则会导致侧边栏数据与元素更新后的数据不符
        props.rightSideBarManager?.setPropertyEditorShowAction(PropertyEditorShowActionMap[type]);
        tdw({ ...TdwModuleAndOperation, ...TdwEffectActions[type] });
    };

    const handleMoreEffectSetting = () => {
        hideMenu();
        tdw({ ...TdwModuleAndOperation, ...TdwEffectActions.more });
        props.rightSideBarManager?.setPropertyEditorShowAction(PropertyEditorShowAction.EFFECT_TOGGLE);
    };

    const handlePresetStyleClick = (type, effectProps) => {
        if (presetElementType === PresetElementType.TEXT) {
            updateTextPreviewState(false);
            updateEffectProps(type, effectProps);
        } else {
            const { previewService } = props;
            previewService?.updateElementPreviewState(false);
            updateEffectProps(type, effectProps);
        }
    };

    const handlePresetStyleEnter = (type, effectProps) => {
        const { previewService, checkSelectType, presetElementType } = props;
        if (checkSelectType && checkSelectType() > 1) {
            return;
        }
        if (presetElementType === PresetElementType.TEXT) {
            updateTextPreviewState(true);
            updateTextEffect(type, effectProps);
        } else {
            previewService?.updateElementPreviewState(true);
            updateModelEffectByType(type, effectProps, true);
        }
    };

    const handlePresetStyleMouseLeave = (type) => {
        const { previewService, checkSelectType } = props;
        if (checkSelectType && checkSelectType() > 1) {
            return;
        }
        const effectValue = menuValueProps?.[type];
        const effectProps = effectValue && Object.keys(effectValue).length > 0
            ? effectValue : PresetUtilFactory.getPresetUtil(type).getDefaultEffectProps();
        const newProps = { ...effectProps };
        switch (type) {
            case ActionType.SHADOW:
                newProps.sizeX = newProps.sizeX || 0;
                newProps.sizeY = newProps.sizeY || 0;
                newProps.skewX = newProps.skewX || 0;
                break;
            default:
                break;
        }
        if (presetElementType === PresetElementType.TEXT) {
            props.callbackByActionType?.(ActionType.FONT_REFRESH);
            updateTextPreviewState(false);
        } else {
            updateModelEffectByType(type, newProps, true);
            previewService?.updateElementPreviewState(false);
        }
    };


    const updateEffectProps = (type, effectProps) => {
        const { previewService, checkSelectType } = props;
        if (checkSelectType && checkSelectType() <= 1) {
            previewService?.updateElementPreviewState(false);
        }
        const defaultEffectProps = PresetUtilFactory.getPresetUtil(type).getDefaultEffectProps();
        let effectValue;
        switch (type) {
            case ActionType.SHADOW:
                effectValue = { ...defaultEffectProps, ...{ algn: null }, ...effectProps };
                break;
            default:
                effectValue = { ...defaultEffectProps, ...effectProps };
                break;
        }
        if (presetElementType === PresetElementType.TEXT) {
            updateTextEffect(type, effectValue, false);
        } else {
            updateModelEffectByType(type, effectValue, false);
        }
    };

    const updateModelEffectByType = (type, effectProps, onlyChangeUI) => {
        const model = props.selectionService.getSelectedModel() as IElementBaseModel;
        switch (type) {
            case ActionType.SHADOW: {
                return model.getEffect?.().updateShadow(effectProps, onlyChangeUI);
            }
            case ActionType.REFLECTION: {
                return model.getEffect?.().updateReflection(effectProps, onlyChangeUI);
            }
            case ActionType.GLOW: {
                return model.getEffect?.().updateGlow(effectProps, onlyChangeUI);
            }
            case ActionType.SOFTEDGE: {
                return model.getEffect?.().updateSoftEdge(effectProps, onlyChangeUI);
            }
            default:
                break;
        }
    };

    const updateTextEffect = (type, effectProp, onlyChangeUI?) => {
        const values = { [ActionType.EFFECT]: {} };
        switch (type) {
            case ActionType.SHADOW: {
                values[ActionType.EFFECT][ActionType.SHADOW] = effectProp;
                break;
            }
            case ActionType.REFLECTION: {
                values[ActionType.EFFECT][ActionType.REFLECTION] = effectProp;
                break;
            }
            case ActionType.GLOW: {
                values[ActionType.EFFECT][ActionType.GLOW] = effectProp;
                break;
            }
            case ActionType.SOFTEDGE: {
                values[ActionType.EFFECT][ActionType.SOFTEDGE] = effectProp;
                break;
            }
            default:
                break;
        }
        getPropertyMenu()?.callback('', ActionType.FONT_EFFECT, values, { onlyChangeUI, onlyPreview: onlyChangeUI });
    };

    const updateTextPreviewState = (isPreview: boolean): void => {
        getTextEditorStateService().isTextPreview = isPreview;
    };

    const getTextEditorStateService = () => (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
        .viewableServiceLayer.textEditorStateService;

    const handleWheel = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const getPresetMenu = (type) => {
        const effectValue = presetElementType === PresetElementType.TEXT ? getFontEffect(type) : menuValue?.[type];
        const presetStyle = PresetUtilFactory.getPresetUtil(type).getPresetStyle(effectValue || {});
        const preset = { style: presetStyle.iconName };
        switch (type) {
            case ActionType.SHADOW: {
                return (
                    <ShadowPresetMenu
                        preset={preset}
                        presetElementType={presetElementType}
                        onShadowPresetStyleClick={value => handlePresetStyleClick(type, value)}
                        onShadowPresetStyleMouseEnter={value => handlePresetStyleEnter(type, value)}
                        onShadowPresetStyleMouseLeave={() => handlePresetStyleMouseLeave(type)}
                    />
                );
            }
            case ActionType.REFLECTION: {
                return (
                    <ReflectionPresetMenu
                        preset={preset}
                        presetElementType={presetElementType}
                        onReflectionPresetStyleClick={value => handlePresetStyleClick(type, value)}
                        onReflectionPresetStyleMouseEnter={value => handlePresetStyleEnter(type, value)}
                        onReflectionPresetStyleMouseLeave={() => handlePresetStyleMouseLeave(type)}
                    />
                );
            }
            case ActionType.GLOW: {
                return (
                    <GlowPresetMenu
                        preset={preset}
                        presetElementType={presetElementType}
                        themeColors={themeColorManager?.currentThemeModel?.clrScheme}
                        onGlowPresetStyleClick={value => handlePresetStyleClick(type, value)}
                        onGlowPresetStyleMouseEnter={value => handlePresetStyleEnter(type, value)}
                        onGlowPresetStyleMouseLeave={() => handlePresetStyleMouseLeave(type)}
                    />
                );
            }
            case ActionType.SOFTEDGE: {
                return (
                    <SoftEdgePresetMenu
                        preset={preset}
                        presetElementType={presetElementType}
                        onSoftEdgePresetStyleClick={value => handlePresetStyleClick(type, value)}
                        onSoftEdgePresetStyleMouseEnter={value => handlePresetStyleEnter(type, value)}
                        onSoftEdgePresetStyleMouseLeave={() => handlePresetStyleMouseLeave(type)}
                    />
                );
            }
            default:
                return null;
        }
    };

    const showMore = props.showMore ?? true;
    const list = [...data];
    if (presetElementType === PresetElementType.TEXT) {
        _remove(list, item => item.type === ActionType.SOFTEDGE);
    }
    return (
        <React.Fragment>
            <div className={styles['no-effect-item']} onClick={clearAllEffects}>
                <span>{i18n.t('无效果')}</span>
            </div>
            <Menu selectable={false} style={menuStyle} className="effect-menu-list-for-e2e-locate">
                {list.map(({ type, content, icon }) =>
                    (!showPresetMenu ? (
                        <Menu.Item
                            key={`toolbar-${type}`}
                            id={`toolbar-${type}`}
                            onClick={() => naviToEffectMenuOnPropertyEditor(type)}
                            className="effect-menu-item-for-e2e-locate"
                            icon={icon}
                        >
                            {content}
                        </Menu.Item>
                    ) : (
                        <Menu.SubMenu key={`toolbar-${type}`} title={content} selectable={false} popupStyle={{ padding: 0 }}>
                            <div className="toolbar-effect-preset-panel" onWheel={handleWheel}>
                                {getPresetMenu(type)}
                                <Divider
                                    key={'effect-divider'}
                                    orientation="horizontal"
                                    style={{
                                        verticalAlign: 'middle',
                                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                        opacity: 0.82,
                                    }}
                                />
                                <Menu.Item
                                    style={{
                                        margin: '8px 0',
                                    }}
                                    onClick={() => naviToEffectMenuOnPropertyEditor(type)}
                                >
                                    {i18n.t(`更多${content}设置`)}
                                </Menu.Item>
                            </div>
                        </Menu.SubMenu>
                    )))}
                {
                    showMore
                        ? <>
                            <Divider
                                key={'effect-divider'}
                                orientation="horizontal"
                                style={{
                                    verticalAlign: 'middle',
                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                    opacity: 0.82,
                                }}
                            />
                            <Menu.Item
                                key={`toolbar-${'effect-item'}`}
                                id={`toolbar-${'effect-item'}`}
                                onClick={handleMoreEffectSetting}
                                icon={MoreSettingIcon}
                                className="effect-item-extra"
                            >
                                {i18n.t('更多设置')}
                            </Menu.Item></> : null
                }
            </Menu>
        </React.Fragment>
    );
};

export default EffectMenu;
